require('./index.scss')
import { useSelector } from 'react-redux'

import {
  isMarketplaceSelector,
  isPrintAssetSelector,
  studentStorePolicySelector
} from '@/selectors'
import { translate } from '@/utils/translations'

const Header = () => {
  const isBulkEnabled = useSelector(state => state.currentRegion.bulkEnabled)
  const studentStorePolicy = useSelector(studentStorePolicySelector)

  const isPrintAsset = useSelector(isPrintAssetSelector)
  const isMarketplace = useSelector(isMarketplaceSelector)
  const printVariantLabel = isMarketplace
    ? translate('common.print_variants.marketplace')
    : translate('common.kind.print')

  return (
    <h3 className='mb-3'>
      <Choose>
        <When condition={isBulkEnabled && !isPrintAsset}>
          {translate('layouts.footer.return_policy')}
        </When>
        <When condition={isPrintAsset}>
          <>
            {translate('return_policy.pdp_tab.vst_return_policy')}
            {` - ${printVariantLabel}`}
          </>
        </When>
        <Otherwise>
          {studentStorePolicy}
        </Otherwise>
      </Choose>
    </h3>
  )
}

export default Header
